import { MapLimits } from 'src/types/mapLimits';
import { createAsyncAction } from 'typesafe-actions';

export const getMapLimits = createAsyncAction(
  '@MAP_LIMITS/GET_MAP_LIMITS_REQUEST',
  '@MAP_LIMITS/GET_MAP_LIMITS_SUCCESS',
  '@MAP_LIMITS/GET_MAP_LIMITS_FAILURE'
)<undefined, MapLimits, Error>();
